import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import InstagramSliderProfileInfo
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderProfileInfo';
import InstagramSliderLinkedPosts
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderLinkedPosts';
import InstagramSliderOptionDropdown
  from 'components/dashboard/image-slider/instagram-slider/InstagramSliderOptionDropdown';

import './InstagramSliderVerified.scss';

function InstagramSliderVerified(props) {
  const { item } = props;
  const { t } = useTranslation();

  const postsNumberOptions = [
    {
      key: '1',
      text: t("1 Post"),
      value: 1,
    },
    {
      key: '3',
      text: t("3 Posts"),
      value: 3,
    },
    {
      key: '6',
      text: t("6 Posts"),
      value: 6,
    },
    {
      key: '12',
      text: t("12 Posts"),
      value: 12,
    },
  ];

  const itemsPerRowOptions = [
    {
      key: '1',
      text: t("1 Item"),
      value: 1,
    },
    {
      key: '2',
      text: t("2 Items"),
      value: 2,
    },
    {
      key: '3',
      text: t("3 Items"),
      value: 3,
    },
  ];

  return (
    <div className="instagram-slider-verified__component">
      <InstagramSliderProfileInfo item={item} />
      <InstagramSliderOptionDropdown
        key={`instagram-slider-option-dropdown-posts-number-key-${item.id}`}
        item={item}
        label={t('Show Recent')}
        options={postsNumberOptions}
        initialValue={item.posts_number}
        parameter="posts_number"
      />
      <InstagramSliderOptionDropdown
        key={`instagram-slider-option-dropdown-items-per-row-key-${item.id}`}
        item={item}
        label={t('Items Per Row')}
        options={itemsPerRowOptions}
        initialValue={item.items_per_row}
        parameter="items_per_row"
      />
      <InstagramSliderLinkedPosts item={item} />
    </div>
  );
}

InstagramSliderVerified.propTypes = {
  item: PropTypes.object.isRequired,
};

export default InstagramSliderVerified;
